import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { UserRoles } from 'types/roles';
import keycloak from '../../Keycloak';

// ==============================|| AUTH ROLE GUARD ||============================== //

const AuthRoleGuard = ({ element, notAllowedRoles }: { element: ReactElement; notAllowedRoles: UserRoles[] }) => {
    const isNotAllowed = keycloak.realmAccess?.roles.some((role) => notAllowedRoles.includes(role as UserRoles));
    return isNotAllowed ? <Navigate to="/" /> : element;
};

export default AuthRoleGuard;
